import { render, staticRenderFns } from "./index3.vue?vue&type=template&id=6d8c4a70&scoped=true&"
import script from "./index3.vue?vue&type=script&lang=js&"
export * from "./index3.vue?vue&type=script&lang=js&"
import style0 from "./index3.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8c4a70",
  null
  
)

export default component.exports